import { render, staticRenderFns } from "./addAsr.vue?vue&type=template&id=cb85ce2a&scoped=true"
import script from "./addAsr.vue?vue&type=script&lang=js"
export * from "./addAsr.vue?vue&type=script&lang=js"
import style0 from "./addAsr.vue?vue&type=style&index=0&id=cb85ce2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb85ce2a",
  null
  
)

export default component.exports